import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SearchCrediflowQueryVariables = Types.Exact<{
  orgNr?: Types.InputMaybe<Types.Scalars['String']>;
  gln?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type SearchCrediflowQuery = { __typename?: 'HyperionSchemaQuery', company?: { __typename?: 'Company', crediflowSearch?: { __typename?: 'CrediflowPartyConnection', edges?: Array<{ __typename?: 'CrediflowPartyEdge', node?: { __typename?: 'CrediflowParty', id?: number | null, name?: string | null, address1?: string | null, address2?: string | null, countrycode?: string | null, zipcode?: string | null, city?: string | null, phone?: string | null, contactname?: string | null, email?: string | null, cin?: string | null, gln?: string | null, vat?: string | null, bankgiro?: string | null, plusgiro?: string | null, iban?: string | null, bic?: string | null, requiresConfirmation?: boolean | null } | null } | null> | null } | null } | null };

export const SearchCrediflowDocument = gql`
    query searchCrediflow($orgNr: String, $gln: String) {
  company {
    crediflowSearch(orgNr: $orgNr, gln: $gln) {
      edges {
        node {
          id
          name
          address1
          address2
          countrycode
          zipcode
          city
          phone
          contactname
          email
          cin
          gln
          vat
          bankgiro
          plusgiro
          iban
          bic
          requiresConfirmation
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCrediflowGQL extends Apollo.Query<SearchCrediflowQuery, SearchCrediflowQueryVariables> {
    document = SearchCrediflowDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }